import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { faPhone, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faHeart,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import DownArrow from "../home/banner/Animation/DownArrow";

const Footer = () => {
  const links = [
    {
      name: "Home",
      BaseLink: "/",
    },
    {
      name: "About Us",
      BaseLink: "/about-us",
    },

    {
      name: "Contact Us",
      BaseLink: "/contact-us",
    },
    {
      name: "Privacy Policy",
      BaseLink: "/privacy-policy",
    },
    {
      name: "Terms & Conditions",
      BaseLink: "/terms-condition",
    },
  ];

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section className="footer_div">
        <Container>
          <div className="footscrool">
            <img
              className="top-layer"
              src={process.env.PUBLIC_URL + "/assets/images/icons/Union.png"}
            />
            <div className="topscroll_div" onClick={handleScrollToTop}>
              <DownArrow />
            </div>
          </div>

          <div className="whatsec">
            <a target="_blank" class="webwhats" href="https://web.whatsapp.com">
              <img
                class="whatsapp-img"
                src={
                  process.env.PUBLIC_URL + "/assets/images/icons/whatsapp.png"
                }
              />
            </a>

            <a target="_blank" class="mobwhats" href="https://wa.me/9836886605">
              <img
                class="whatsapp-img"
                src={
                  process.env.PUBLIC_URL + "/assets/images/icons/whatsapp.png"
                }
              />
            </a>
          </div>

          <Row>
            <Col
              xxl={8}
              xl={9}
              lg={10}
              md={11}
              sm={11}
              xs={12}
              className="mx-auto"
            >
              <div className="footermain_div">
                <div className="footer_top">
                  <div className="footlogo-div">
                    <Link to="/">
                      <img
                        className="footlogo"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/logo/bazar-wala2.png"
                        }
                      />
                    </Link>
                  </div>

                  <div className="d-flex justify-content-around flex-wrap">
                    {links.map((text, index) => (
                      <div className="top_div_footer  ">
                        <Link to={text.BaseLink}>
                          <p className="top_text px-2">{text.name}</p>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="footer_miidle">
                  <Row>
                    <Col
                      xxl={8}
                      xl={8}
                      lg={7}
                      md={8}
                      sm={10}
                      xs={12}
                      className="mx-auto"
                    >
                      <div className="top_div_footer">
                        <div className="contact_div padding_div">
                          <p className="top_text">
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className="footericn"
                            />{" "}
                            apusikder60@gmail.com
                          </p>
                          <p className="top_text">
                            <FontAwesomeIcon
                              icon={faPhone}
                              className="footericn"
                            />{" "}
                            +91 9836886605
                          </p>
                        </div>

                        <div className="addres_div padding_div">
                          <p className="top_text">
                            Sahidpally, Kalyani, Nadia - 741251, West Bengal
                          </p>
                        </div>

                        <div className="all_icon padding_div">
                          <Link to="https://www.facebook.com" target="_blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon
                                className="cart_logo"
                                icon={faFacebookF}
                              />
                            </div>
                          </Link>

                          <Link to="https://www.instagram.com" target="_blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon
                                icon={faInstagram}
                                className="cart_logo"
                              />
                            </div>
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <p className="bottom_footer_text">
                  © 2026 BazarWala . All Rights Reserved. Developed by{" "}
                  <Link
                    target="_blank"
                    className="bottom_footer_text"
                    to="https://profcymaglobal.com"
                  >
                    Profcyma
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Footer;
